// hooks/useGroupedCatalogueData.js
import { useState, useEffect } from 'react';

const useSubCatalogueGroupedData = () => {
    const [subGroupedData, setSubGroupedData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSubCatalogueGroupedData = async () => {
            try {
                const response = await fetch("https://backend.nuhababy.com/getSubCataloguesGroupedByCatalouge");

                if (!response.ok) {
                    throw new Error('Failed to fetch grouped catalogue data');
                }

                const result = await response.json();
                setSubGroupedData(result.data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSubCatalogueGroupedData();
    }, []);

    return { subGroupedData, loading, error };
};

export default useSubCatalogueGroupedData;